import { CoreModel } from "@models/CoreModel";

export interface ContactInfo {
  emailAddress: string;
  firstName: string;
  id: number;
  lastName: string;
}

export interface UserMetaData {
  key: string;
  value: string;
}

export class LoginVerificationDataModel {
  authUserId: string;
  companyId: string;
  companyUserId: string;
  contactInfo: ContactInfo;
  dateCreate: number;
  dateModified: number;
  isActive: boolean;
  language: string;
  token: string;
  tokenIsValid: boolean;
  tokenexpires: string;
  userGroupId: string;
  userMetaData: UserMetaData[];

  constructor(builder: LoginVerificationDataModelBuilder) {
    this.authUserId = builder.authUserId;
    this.companyId = builder.companyId;
    this.companyUserId = builder.companyUserId;
    this.contactInfo = builder.contactInfo;
    this.dateCreate = builder.dateCreate;
    this.dateModified = builder.dateModified;
    this.isActive = builder.isActive;
    this.language = builder.language;
    this.token = builder.token;
    this.tokenIsValid = builder.tokenIsValid;
    this.tokenexpires = builder.tokenexpires;
    this.userGroupId = builder.userGroupId;
    this.userMetaData = builder.userMetaData;
  }
}

export class LoginVerificationDataModelBuilder extends CoreModel {
  private _authUserId: string = "";
  private _companyId: string = "";
  private _companyUserId: string = "";
  private _contactInfo: ContactInfo = {
    emailAddress: "",
    firstName: "",
    id: 0,
    lastName: "",
  };
  private _dateCreate: number = 0;
  private _dateModified: number = 0;
  private _isActive: boolean = false;
  private _language: string = "";
  private _token: string = "";
  private _tokenIsValid: boolean = false;
  private _tokenexpires: string = "";
  private _userGroupId: string = "";
  private _userMetaData: UserMetaData[] = [];

  constructor() {
    super();
  }

  setAuthUserId(authUserId: string) {
    this._authUserId = authUserId;
    return this;
  }

  setCompanyId(companyId: string) {
    this._companyId = companyId;
    return this;
  }

  setCompanyUserId(companyUserId: string) {
    this._companyUserId = companyUserId;
    return this;
  }

  setContactInfo(contactInfo: ContactInfo) {
    this._contactInfo = contactInfo;
    return this;
  }

  setDateCreate(dateCreate: number) {
    this._dateCreate = dateCreate;
    return this;
  }

  setDateModified(dateModified: number) {
    this._dateModified = dateModified;
    return this;
  }

  setIsActive(isActive: boolean) {
    this._isActive = isActive;
    return this;
  }

  setLanguage(language: string) {
    this._language = language;
    return this;
  }

  setToken(token: string) {
    this._token = token;
    return this;
  }

  setTokenIsValid(tokenIsValid: boolean) {
    this._tokenIsValid = tokenIsValid;
    return this;
  }

  setTokenexpires(tokenexpires: string) {
    this._tokenexpires = tokenexpires;
    return this;
  }

  setUserGroupId(userGroupId: string) {
    this._userGroupId = userGroupId;
    return this;
  }

  setUserMetaData(userMetaData: UserMetaData[]) {
    this._userMetaData = userMetaData;
    return this;
  }

  build() {
    return new LoginVerificationDataModel(this);
  }

  get authUserId(): string {
    return this._authUserId;
  }

  get companyId(): string {
    return this._companyId;
  }

  get companyUserId(): string {
    return this._companyUserId;
  }

  get contactInfo(): ContactInfo {
    return this._contactInfo;
  }

  get dateCreate(): number {
    return this._dateCreate;
  }

  get dateModified(): number {
    return this._dateModified;
  }

  get isActive(): boolean {
    return this._isActive;
  }

  get language(): string {
    return this._language;
  }

  get token(): string {
    return this._token;
  }

  get tokenIsValid(): boolean {
    return this._tokenIsValid;
  }

  get tokenexpires(): string {
    return this._tokenexpires;
  }

  get userGroupId(): string {
    return this._userGroupId;
  }

  get userMetaData(): UserMetaData[] {
    return this._userMetaData;
  }
}
